<vn-header-bar [title]="title" [showBack]="false" [showClose]="closeDisabled !== true" (onClose)="close()" />

<div class="dialog-content">
    <ng-content />
</div>
